import { Phone, UserRound } from "lucide-react";
import { Link } from "react-router-dom";
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuList,
  NavigationMenuTrigger,
} from "@/components/ui/navigation-menu";
import { insuranceLinks } from "./insuranceLinks";
import { useAuthState } from "@/hooks/useAuthState";
import { UserMenu } from "./UserMenu";
import { useIsMobile } from "@/hooks/use-mobile";

const DesktopMenu = () => {
  const { isAuthenticated } = useAuthState();
  const isMobile = useIsMobile();

  if (isMobile) return null;

  return (
    <div className="flex items-center space-x-8">
      <Link to="/about" className="text-neutral hover:text-primary transition">
        About
      </Link>
      <NavigationMenu>
        <NavigationMenuList>
          <NavigationMenuItem>
            <NavigationMenuTrigger className="text-neutral hover:text-primary transition bg-transparent">
              Insurance
            </NavigationMenuTrigger>
            <NavigationMenuContent>
              <div className="grid gap-3 p-4 w-[400px] md:w-[500px] lg:w-[600px]">
                {insuranceLinks.map((item) => (
                  <Link
                    key={item.title}
                    to={item.href}
                    className="block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground"
                  >
                    <div className="flex items-center space-x-2">
                      <item.icon className="h-5 w-5" />
                      <div className="text-sm font-medium leading-none">{item.title}</div>
                    </div>
                    <p className="line-clamp-2 text-sm leading-snug text-muted-foreground mt-2">
                      {item.description}
                    </p>
                  </Link>
                ))}
              </div>
            </NavigationMenuContent>
          </NavigationMenuItem>
        </NavigationMenuList>
      </NavigationMenu>
      <Link to="/quote" className="text-neutral hover:text-primary transition">
        Quote
      </Link>
      {isAuthenticated ? (
        <UserMenu />
      ) : (
        <Link
          to="/auth"
          className="flex items-center text-neutral hover:text-primary transition"
        >
          <UserRound size={24} />
        </Link>
      )}
      <a 
        href="tel:217-909-9777" 
        className="flex items-center space-x-2 bg-primary text-white px-6 py-2 rounded-full hover:bg-primary-dark transition"
      >
        <Phone size={18} />
        <span>217-909-9777</span>
      </a>
    </div>
  );
};

export default DesktopMenu;